import React, { useRef, useState, useLayoutEffect } from 'react';
import { BottomSheet as BottomSheetComponent } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import './BottomSheet.css';

const BottomSheet = ({ header, content, onSetHeight }) => {
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useLayoutEffect(() => {
    if (headerRef.current) {
      const height = headerRef.current.offsetHeight;
      setHeaderHeight(height + 28);
      if (onSetHeight) onSetHeight(height + 28);
    }
  }, []);

  return (
    <>
      {/* Header oculto solo para medir */}
      <div ref={headerRef} style={{ visibility: 'hidden', position: 'absolute' }}>
        <div
          style={{
            padding: 16,
            paddingBottom: 'calc(16px + (env(safe-area-inset-bottom)) * 0.8) ',
          }}
        >
          {header}
        </div>
      </div>

      {headerHeight > 0 && (
        <BottomSheetComponent
          open={true}
          blocking={false}
          snapPoints={({ maxHeight }) => [headerHeight, headerHeight, maxHeight - 45]}
          defaultSnap={({ maxHeight }) => headerHeight}
          skipInitialTransition
          expandOnContentDrag
          animationConfig={{
            tension: 300,
            friction: 50,
          }}
        >
          <>
            <div
              style={{
                padding: 16,
                paddingBottom: 'calc(16px + (env(safe-area-inset-bottom)) * 0.8) ',
              }}
            >
              {header}
            </div>
            <div className="sheet-content">{content}</div>
          </>
        </BottomSheetComponent>
      )}
    </>
  );
};

export default BottomSheet;
